// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ColourList_wrapper__Y4c4R","selectedColour":"ColourList_selectedColour__0gzrb","title":"ColourList_title__6iOWi"};